import { Box, IconButton, Typography } from "@mui/material";
import { T } from "../../util/t";
import { Close } from "@mui/icons-material";

export const FailedPayments = ({ failedPayments, clearFailedPayments }) =>
    failedPayments?.length > 0 && (
        <Box padding={1} borderRadius={1} mb={2} backgroundColor="warn.main">
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Typography variant="subtitle3">
                    <T>payments_failed_for_entries</T>
                </Typography>
                <IconButton
                    color="inherit"
                    size="small"
                    onClick={clearFailedPayments}
                >
                    <Close />
                </IconButton>
            </Box>
            <Box pl={3}>
                {failedPayments.flat().map((entry, index) => (
                    <Typography key={index} variant="body1" component="p">
                        {++index}. {entry.athlete.name}
                    </Typography>
                ))}
                <Typography pt={2}>
                    <T>
                        Request for payment has been sent. Once payment is
                        received, the entry will be confirmed.
                    </T>
                </Typography>
            </Box>
        </Box>
    );
